import { render, staticRenderFns } from "./ButtonMaterialEdit.vue?vue&type=template&id=79c8989e&"
import script from "./ButtonMaterialEdit.vue?vue&type=script&lang=js&"
export * from "./ButtonMaterialEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports